import React, {  useState } from 'react';
import { Collapse, Drawer, List,  ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import sidebarItems from './SidebarConfig';
import { StyledDrawer, DrawerContent, StyledListItem } from './SidebarDrawerStyles';

const SidebarItem = ({ isActive, onClick, menu, activeSubmodules, index, ...props }) =>{
  const navigate = useNavigate();
  const handleClick = () => {
    onClick();
    
    if (!menu.submodules || menu.submodules.length === 0) {
      navigate(menu.path); // Navegar al path si no hay submódulos
    }
  };
  return (
    <Tooltip title={menu.text}>
        <StyledListItem 
          button 
          onClick={() => {
            handleClick()
          }} 
          selected={isActive} 
          {...props}
          >
          {menu.icon && <ListItemIcon  sx={{ color: '#cdcdcd' }}>{menu.icon}</ListItemIcon>}
          <ListItemText primary={menu.text} sx={{ display: 'block', width: 'auto',  whiteSpace: 'nowrap', overflow: 'hidden', transition: 'width 0.3s' }} /> 
            {menu.submodules && menu.submodules.length > 0 && (
              activeSubmodules.includes(index) ? <ExpandLessIcon /> : <ExpandMoreIcon />
            )}
      </StyledListItem>
    </Tooltip>
  )};

const SidebarDrawer = ({isDrawerOpen}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSubmodules, setActiveSubmodules] = useState([]);
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
  const isSuperuser = user ? user.is_superuser : false;
  const toggleSubmodule = (index) => {
    const isOpensub = activeSubmodules.includes(index);
    const newSubmodules = isOpensub
      ? activeSubmodules.filter((i) => i !== index)
      : [...activeSubmodules, index];

    setActiveSubmodules(newSubmodules);
  };

  const filteredItems = sidebarItems.filter(item => {
    if (isSuperuser) {
      return true;  // Si es superusuario, mostrar todos los módulos
    }
    if (!item.requiredPermission) {
      return true;  // Si el módulo no tiene un permiso requerido, mostrarlo
    }
    return permissions ? permissions.includes(item.requiredPermission) : false;

  });
  const navigateToSubmodule = (path) => navigate(path);

  return (
    <Drawer 
      variant="persistent" 
      open={isDrawerOpen} 
      >
      <DrawerContent>
        <List>
          {filteredItems.map((menu, index) => {
            const filteredSubmodules = menu.submodules.filter(submodule => {
              if (isSuperuser) return true;
              if (!submodule.requiredPermission) return true;
              return permissions.includes(submodule.requiredPermission);
            });

            return (
              <div key={menu.text}>
                <SidebarItem 
                  menu = {menu}
                  activeSubmodules={activeSubmodules}
                  index={index}
                  isActive={location.pathname.startsWith(menu.text.toLowerCase()) ?? activeSubmodules.includes(index)}
                  onClick={() => toggleSubmodule(index)}
                />
                <Collapse in={activeSubmodules.includes(index)} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {filteredSubmodules.map((submenu,index) => (
                      <SidebarItem 
                        key={index}
                        menu ={submenu}
                        isActive={location.pathname === submenu.path}
                        onClick={() => navigateToSubmodule(submenu.path)}
                        sx={{ paddingLeft: '40px' }}
                      />
                    ))}
                  </List>
                </Collapse>
              </div>
            );
          })}
        </List>
      </DrawerContent>
    </Drawer>
  );
};

export default SidebarDrawer;